export const generateUrl = (
  url: string,
  params: Record<string, string | string[] | number>,
): string => {
  if (params === undefined) {
    return url;
  }

  const baseUrl = url;
  const queryParams: string[] = [];

  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null && value !== '') {
      if (Array.isArray(value)) {
        value.forEach((val) => {
          queryParams.push(`${key}[]=${val}`);
        });
      } else {
        queryParams.push(`${key}=${value}`);
      }
    }
  }

  if (queryParams.length === 0) {
    return baseUrl;
  }

  return `${baseUrl}?${queryParams.join('&')}`;
};
